import TwinTrans from '../../../../baseComponents/TwinTrans'
import { displayFormatedHourFromMins } from '../../../../utils/globals/date'

interface RenderScheduleProps {
    workingTime: number[][]
}

export const RenderSchedule: React.FC<RenderScheduleProps> = ({ workingTime }) => {
    const renderSchedule: JSX.Element[] = []
    if (workingTime.length) {
        for (const element of workingTime) {
            renderSchedule.push(<RenderScheduleRow timeRow={element} key={element[0] + element[1]} className='light12' />)
        }
        return <div>{renderSchedule}</div>
    }
    return null
}
interface RenderScheduleJoinProps {
    workingTime: number[][]
}

export const RenderScheduleJoin: React.FC<RenderScheduleJoinProps> = ({ workingTime }) => {
    const renderSchedule: JSX.Element[] = []
    if (workingTime.length) {
        for (const element of workingTime) {
            if (renderSchedule.length) {
                renderSchedule.push(<span key={ element[0] + element[1] + '/' }> / </span>)
            }
            renderSchedule.push(<RenderScheduleRow timeRow={element} key={element[0] + element[1]} />)
        }
        return <div className='flex gap-2'>{renderSchedule}</div>
    }
    return null
}

interface RenderScheduleRowProps {
    timeRow: number[]
    className?: string
}

export const RenderScheduleRow: React.FC<RenderScheduleRowProps> = ({ timeRow, className }) => {
    const isAllDay = timeRow[0] === 0 && timeRow[1] === 0
    if (isAllDay) {
        return <div className={className || ''} key={timeRow[0] + '-' + timeRow[1]}><TwinTrans transKey='allDay'>Todo el día</TwinTrans></div>
    }
    return (
        <div className={className ||''} key={timeRow[0] + '-' + timeRow[1]}>
            {displayFormatedHourFromMins(timeRow[0])}
            <span> - </span>
            {displayFormatedHourFromMins(timeRow[1])}
        </div>
    )
}
